import React from "react";
import "./ResultsParts.scss";

export const PERIODS = [
  { days: 7, label: "7 days" },
  { days: 30, label: "30 days" },
  { days: 90, label: "90 days" },
];

export const PeriodSwitch = ({ value, onChange }) => (
  <div className="results-period" role="group" aria-label="Time period">
    {PERIODS.map((period) => (
      <button
        key={period.days}
        type="button"
        className={`results-period__option${period.days === value ? " is-on" : ""}`}
        aria-pressed={period.days === value}
        onClick={() => onChange(period.days)}
      >
        {period.label}
      </button>
    ))}
  </div>
);

export const EmptyState = ({ title, body, action }) => (
  <div className="results-empty">
    <p className="results-empty__title">{title}</p>
    {body ? <p className="results-empty__body">{body}</p> : null}
    {action ? (
      <button type="button" className="btn btn-primary results-empty__action" onClick={action.onClick}>
        {action.label}
      </button>
    ) : null}
  </div>
);

export { MetricTabs, TrendChart, Overview } from "./ResultsTrend";
export { Breakdown, BreakdownRows } from "./ResultsBreakdown";
export { Headline } from "./ResultsHeadline";

export const GitchaLink = ({ href, children }) =>
  href ? (
    <a className="results-gitcha-link" href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    children
  );

export const ResultsSkeleton = () => (
  <div className="results-skeleton" aria-busy="true" aria-label="Loading analytics">
    <header className="results-headline">
      <div className="results-skeleton__line is-title" />
      <div className="results-skeleton__line is-sub" />
    </header>
    <div className="results-studio">
      <section className="results-card results-skeleton__main" />
      <div className="results-studio__side">
        <div className="results-card results-skeleton__side" />
      </div>
      <div className="results-studio__below">
        <div className="results-card results-skeleton__feed" />
      </div>
    </div>
    <div className="results-skeleton__combined">
      <div className="results-card results-skeleton__card" />
      <div className="results-card results-skeleton__card" />
    </div>
  </div>
);
